import styles from "./productGallery.module.css";
import productStyles from "../productDetails.module.css";
import { useProductDetails } from "../productContext/ProductProvider";
import EmblaCarousel from "../../embla-carousel/EmblaCarousel";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

function ProductGallery() {
	const { t } = useTranslation();
	const { assetData, setAssetPopUpId, derivedAssetType } = useProductDetails();

	const productImagesId = derivedAssetType?.["Product Shot"] ?? [];

	const carouselList = useMemo(() => {
		return productImagesId
			.map((id) => assetData?.[id])
			.filter(Boolean)
			.map((asset) => ({
				id: asset.id,
				image: asset?.largeAssetPath,
				alt: asset?.fileName,
			}));
	}, [productImagesId, assetData]);

	const OPTIONS = { dragFree: true, loop: true };

	const handleOnImgClick = (event) => {
		setAssetPopUpId(event.target.id);
	};

	return (
		<section className={`${productStyles.section} ${styles.productGallery}`}>
			<div className={`${productStyles.title} ${styles.galleryTitle}`}>
				{t("Gallery")}
			</div>
			<div className={styles.productGallery__carousel}>
				<EmblaCarousel
					options={OPTIONS}
					slides={carouselList}
					onClick={handleOnImgClick}
				/>
			</div>
		</section>
	);
}

ProductGallery.shouldRender = ({ derivedAssetType }) =>
	(derivedAssetType?.["Product Shot"]?.length ?? 0) > 0;

export default ProductGallery;